// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"japanese-rectangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4V20H2L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4V20L2 20L2 4L22 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 12.2143V9H17.5C17.7761 9 18 9.19188 18 9.42857V11.7857C18 12.0224 17.7761 12.2143 17.5 12.2143H14ZM14 12.2143V15M6 15H9.6C9.82091 15 10 14.9041 10 14.7857V9H7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const JapaneseRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'japanese-rectangle',
    ref,
    icon: element,
  },
));

JapaneseRectangleIcon.displayName = 'JapaneseRectangleIcon';

export default JapaneseRectangleIcon;
